// extracted by mini-css-extract-plugin
export default {"App":"app_App__l7J6k"};